/* src/app/layout/layout/layout.component.scss */
.content-container {
  background-color: #FFFFFF;
  margin: 30px;
  margin-bottom: 60px;
}
/*# sourceMappingURL=layout.component.css.map */
